import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
} from '@tanstack/react-query'

import { Parking } from '../../../@types/entities/entities.types'

export type UseParkingReturn = {
  parkings: Parking[]
  setParkings: React.Dispatch<React.SetStateAction<Parking[]>>
  refetch: <TPageData>(
    options?: RefetchOptions & RefetchQueryFilters<TPageData>
  ) => Promise<QueryObserverResult<Parking[], unknown>>
  isRefetching: boolean
}

export const ParkingCharacteristic = {
  open_24_hours: 'Aberto 24 horas',
  indoor_parking: 'Estacionamento coberto',
  valet_parking: 'Manobrista',
  vacant_bike: 'Tem vaga para bike',
  electric_car_charging: 'Recarga carro elétrico',
  accessibility: 'Acessibilidade',
  safe: 'Seguro',
  security_camera: 'Câmera de segurança',
  on_site_agreements: 'Convênios no local',
  need_to_leave_key: 'Necessário deixar chave',
  parkoff_pass: 'ParkOff Pass',
}
